// extracted by mini-css-extract-plugin
export var highlight = "product-detail-highlight-module--highlight--f4469";
export var highlightContent = "product-detail-highlight-module--highlightContent--e39ce";
export var highlightDescription = "product-detail-highlight-module--highlightDescription--b575f";
export var highlightImage = "product-detail-highlight-module--highlightImage--ade9e";
export var highlightVideo = "product-detail-highlight-module--highlightVideo--14c99";
export var highlights = "product-detail-highlight-module--highlights--eb19b";
export var next = "product-detail-highlight-module--next--e794a";
export var prev = "product-detail-highlight-module--prev--213fa";
export var soloHighlight = "product-detail-highlight-module--soloHighlight--abfa1";
export var wrapper = "product-detail-highlight-module--wrapper--9a5ad";